var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3 mt-3"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-auto"},[_c('b-icon',{attrs:{"icon":_vm.icon,"font-scale":"2"}})],1),_c('div',{staticClass:"col pl-0"},[_c('div',[_c('small',[_c('b',[_vm._v(_vm._s(_vm.text))])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }